module.exports = __webpack_public_path__ + "static/media/masaladosa.6e10c7c0.jpg";